import { FC } from 'react'
import {
  BooleanInput, Create, ReferenceInput, SelectInput, SimpleForm,
  TextInput, required, useGetOne,
} from 'react-admin'
import { useWatch } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { LOG_LEVEL_CHOICES, EnvironmentSelector } from '../../components'
import Auth0UserField from '../../components/Auth0UserField'
import { ProxyOut } from '../../types/apiRequests'

const ProxyEnvironmentSelector: FC = () => {
  const proxyId = useWatch({ name: 'proxy_id' }) as string | undefined

  const { data: proxy } = useGetOne<ProxyOut>(
    'proxy',
    { id: proxyId ?? '' },
    { enabled: !!proxyId },
  )

  if (!proxyId) return null

  return <EnvironmentSelector applicationId={proxy?.application_id} />
}

const isProxyLinkState = (s: unknown): s is { organization_id?: string; proxy_id?: string } =>
  typeof s === 'object' && s !== null

const OrganizationProxyLinkCreate: FC = () => {
  const location = useLocation()
  const state = isProxyLinkState(location.state) ? location.state : undefined

  return (
    <Create redirect="edit">
      <SimpleForm defaultValues={{
        // eslint-disable-next-line camelcase
        organization_id: state?.organization_id || '',
        // eslint-disable-next-line camelcase
        proxy_id: state?.proxy_id || '',
        enabled: true,
      }}>
        {/* eslint-disable-next-line camelcase */}
        <ReferenceInput source="organization_id" reference="organization">
          <SelectInput optionText="display_name" label="data.organization" fullWidth validate={required()} />
        </ReferenceInput>
        {/* eslint-disable-next-line camelcase */}
        <ReferenceInput source="proxy_id" reference="proxy">
          <SelectInput optionText="display_name" label="data.proxy" fullWidth validate={required()} />
        </ReferenceInput>
        <ProxyEnvironmentSelector />
        <Auth0UserField />
        <TextInput source="target_url" label="data.targetUrl" fullWidth validate={required()} />
        <BooleanInput source="enabled" label="data.enabled" defaultValue={true} />
        <SelectInput
          source="log_level"
          label="data.logLevel"
          choices={LOG_LEVEL_CHOICES}
          defaultValue="normal"
        />
      </SimpleForm>
    </Create>
  )
}

export default OrganizationProxyLinkCreate
